/**
 * DEV-2330. Результат задачи: поле при закрытии галочкой, показ у закрытых,
 * модалка на борде. Строки общие для карточки сделки, карточки клиента и
 * раздела «Задачи», поэтому не в tasksBoard.ts.
 */
export const taskResultMessages = {
  ru: {
    tasks: {
      result: {
        label: 'Результат',
        placeholder: 'Что сделано по задаче',
        requiredHint: 'Обязательно для задачи воронки, не короче {n} символов',
        optionalHint: 'Необязательно, но если пишете — не короче {n} символов',
        complete: 'Выполнить',
        requiredError: 'Для задачи воронки нужен результат',
        minLengthError: 'Результат не короче {n} символов',
        shown: 'Результат: {result}',
        autoClosed: 'Закрыта автоматически',
        modalTitle: 'Выполнить задачу',
        column: 'Результат',
      },
    },
  },
  en: {
    tasks: {
      result: {
        label: 'Result',
        placeholder: 'What was done',
        requiredHint: 'Required for a pipeline task, at least {n} characters',
        optionalHint: 'Optional, but at least {n} characters if filled',
        complete: 'Complete',
        requiredError: 'A pipeline task needs a result',
        minLengthError: 'The result must be at least {n} characters',
        shown: 'Result: {result}',
        autoClosed: 'Closed automatically',
        modalTitle: 'Complete the task',
        column: 'Result',
      },
    },
  },
  vn: {
    tasks: {
      result: {
        label: 'Kết quả',
        placeholder: 'Đã làm gì cho nhiệm vụ',
        requiredHint: 'Bắt buộc với nhiệm vụ của quy trình, ít nhất {n} ký tự',
        optionalHint: 'Không bắt buộc, nhưng nếu điền thì ít nhất {n} ký tự',
        complete: 'Hoàn thành',
        requiredError: 'Nhiệm vụ của quy trình cần có kết quả',
        minLengthError: 'Kết quả phải có ít nhất {n} ký tự',
        shown: 'Kết quả: {result}',
        autoClosed: 'Đã đóng tự động',
        modalTitle: 'Hoàn thành nhiệm vụ',
        column: 'Kết quả',
      },
    },
  },
}
